import * as React from 'react';

var useLatest = function useLatest(current) {
  var storedValue = React.useRef(current);
  React.useEffect(function () {
    storedValue.current = current;
  });
  return storedValue;
};

export default useLatest;